import React from 'react';
import { Form } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import { quillFormats, quillModules } from '../../../Utils/GlobalConfigs';

const ShortDescription = ({ value, onChange, error }) => {
    return (
        <div>
            <Form.Group className="mb-4" >
                <ReactQuill
                    style={{ height: 300 }}
                    theme="snow"
                    modules={quillModules}
                    formats={quillFormats}
                    value={value}
                    onChange={onChange}

                />
                <br />
                <br />
                {error && (<p className="errMsg">{error}</p>)}
            </Form.Group>
        </div>
    );
};

export default ShortDescription;

